import { _ } from '@ngx-translate/core';
import { DialogEventTabs } from '@app/main/leak-detection/dialogs/dialog-event/enums/dialog-event-tabs.enum';

export const dialogEventTabsLocalize: Record<DialogEventTabs, string> = {
  [DialogEventTabs.Details]: _(`@@fp-event-tab__details`),
  [DialogEventTabs.History]: _(`@@fp-event-tab__history`),
};
